import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@nibtravel/shared/ui/components/icon';
import { DomModule } from '@nibtravel/shared/util/dom';

import { SidebarComponent } from './sidebar.component';
import { SidebarService } from './sidebar.service';

@NgModule({
  imports: [CommonModule, A11yModule, IconModule, DomModule],
  declarations: [SidebarComponent],
  exports: [SidebarComponent],
  providers: [SidebarService],
})
export class SidebarModule {}
